import Engine from "client/classes/Engine";
import ProjectLoader from "client/classes/ProjectLoader";
import RbopLoader from "client/classes/RbopLoader";
import ScenarioHealthUtils from "client/classes/utilities/ScenarioHealthUtils";
import sleep from "client/classes/utilities/sleep";
import StandbyOverlay from "client/components/layout/StandbyOverlay";
import { CustomEventTypes, SimulationStates } from "client/globals";
import { ProjectLoadingEvents, ProjectLoadingStates } from "client/interfaces/enums";
import { IProjectInfo } from "client/interfaces/ScenarioElements";
import Store, { StoreActions } from "client/state/store";

export default class ScenarioLoader extends ProjectLoader
{
	async loadScenario(projectFileURL : string, projectData: IProjectInfo)
	{
		console.log("Loading project " + projectFileURL);
  
		return new Promise<void>((resolve, reject) =>
		{
			document.dispatchEvent(new CustomEvent(CustomEventTypes.onProjectLoadStart));
			Store.dispatch(StoreActions.application.setSimulationState(SimulationStates.Stopped));
			Engine.getInstance().clearProjectData();
  
			this.state = ProjectLoadingStates.DOWNLOADING_PROJECT_FILE;

			this.readProjectFile(projectFileURL).then(async (blob) =>
			{
				try 
				{
					const { saveJSON, uiDataJSON, timelineDataJSON, sceneDatas } =  await ProjectLoader.extractBlob(blob);
      
					Store.dispatch(StoreActions.files.registerExports([]));
					Store.dispatch(StoreActions.files.registerImports([]));
					Store.dispatch(StoreActions.history.clearDirtyAction());

					if(!saveJSON) throw new Error("Failed to load project file");

					// detetct zip file
					const projectData = JSON.parse(saveJSON);
					if (projectData.SiemensRBOP)
					{
						const loader = new RbopLoader(projectData);
						await sleep();
						await loader.load();
						this.centerInteractiveCameraOnContent();
						StandbyOverlay.stopStandbyMode();
					}
					else if (projectData.version)
					{
						this.version = projectData.version;
						await sleep();
						await this.loadProjectData(projectData, uiDataJSON, timelineDataJSON, sceneDatas);
          
						StandbyOverlay.stopStandbyMode();
						window.dispatchEvent(new Event('resize'));
						document.dispatchEvent(new CustomEvent(CustomEventTypes.onProjectLoadEnd));
						ScenarioHealthUtils.FullHealthCheck();
						resolve();	
					}
				}
				catch (error)
				{
					StandbyOverlay.stopStandbyMode();
					ProjectLoader.projectLoadFailed(projectData._id, error);
					resolve();
				}
			}, (error) =>
			{
				StandbyOverlay.stopStandbyMode();
				ProjectLoader.projectLoadFailed(projectData._id, error);
				resolve();
			});
		});
	}
}